import type { FC } from 'react';
import AntUpload from 'antd/es/upload';
import type { UploadProps as AntUploadProps, UploadFile } from 'antd/es/upload';
import { cn } from 'app/lib/utils';

export interface UploadProps extends AntUploadProps {}

const UploadBase: FC<UploadProps> = ({ className, ...rest }) => (
  <AntUpload className={cn(className)} {...rest} />
);

const Dragger: FC<UploadProps> = ({ className, ...rest }) => (
  <AntUpload.Dragger className={cn(className)} {...rest} />
);

/**
 * File upload façade over antd `Upload`; File/Image fields use different antd
 * surfaces (`Dragger` vs `picture-card`), so no shared default chrome is baked in.
 */
export const Upload = UploadBase as typeof UploadBase & {
  Dragger: typeof Dragger;
  // antd's sentinel for "reject this file without adding it to the list" — returned from beforeUpload.
  LIST_IGNORE: typeof AntUpload.LIST_IGNORE;
};
Upload.Dragger = Dragger;
Upload.LIST_IGNORE = AntUpload.LIST_IGNORE;

export type { UploadFile };
export default Upload;
